

























import { Vue, Component, PropSync, Prop } from 'vue-property-decorator'
import { TipoDePagamento } from '@/models'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import DialogoDeTipoDePagamento, { criarTipoDePagamento } from './DialogoDeTipoDePagamento.vue'
import { v4 as uuidv4 } from 'uuid'

@Component({
	components: {
		DataTableDeCrud,
		DialogoDeTipoDePagamento,
	},
})
export default class TableDeTiposDePagamento extends Vue {
	@PropSync('value') tipos!: TipoDePagamento[]
	@Prop({ type: Boolean, default: false}) mostraPagamentoTEF!: boolean

	headers = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'Forma', value: 'formaDePagamento' },
		{ text: 'Parcelas', value: 'displayParcelas' },
		{ text: 'Ordem', value: 'ordem' },
	]

	carregando = false

	busca = ''

	mostraDialogo = false

	get temConsignado() {
		return this.tipos.some(tipo => tipo.formaDePagamento === 'Consignado');
	}

	get temDemonstracao() {
		return this.tipos.some(tipo => tipo.formaDePagamento === 'Demonstração');
	}

	tipoDePagamento: TipoDePagamento | null = null

	get tiposDePagamentoFormatados(): DisplayTiposDePagamento[] {
		return this.tipos
			.sort((a, b) => this.ordemParaOrdenar(a.ordem) - this.ordemParaOrdenar(b.ordem))
			.map(
				tipo => ({
					...tipo,
					displayParcelas: tipo.parcelasComTaxas != null
						? tipo.parcelasComTaxas.map(item => item.parcelamentos).sort((pA, pB) =>{
							if( pA < pB) return -1
							if( pA > pB) return 1
							return 0
						}).join(', ')
						: 'Á vista',
				}),
			) 
	
	}

	editar(indice: number) {
		const tipo = this.tipos[indice]
		if (!tipo) return
		this.tipoDePagamento = tipo
		this.mostraDialogo = true
	}

	criar() {
		this.tipoDePagamento = criarTipoDePagamento()
		this.mostraDialogo = true
	}

	salvar(tipo: TipoDePagamento) {
		const isNovo = !tipo.id

		if (isNovo) {
			const novo: TipoDePagamento = {
				...tipo,
				id: uuidv4(),
			}

			this.aplicarReordenacaoPorPosicao(novo, novo.ordem)
			return
		}

		const indice = this.tipos.findIndex(t => t.id === tipo.id)
		if (indice === -1) return

		const existente = this.tipos[indice]
		Object.assign(existente, tipo)

		this.aplicarReordenacaoPorPosicao(existente, existente.ordem)
	}

	remover(indice: number) {
		this.tipos.splice(indice, 1)
		this.$emit('input', [
			...this.tipos,
		])
	}

	get proximaOrdem(): number {
		return (this.tipos?.length || 0) + 1
	}

	normalizarOrdemEntrada(ordem: any): number {
		const n = Math.trunc(Number(ordem))
		return Number.isFinite(n) && n >= 1 ? n : 1
	}

	ordemParaOrdenar(ordem: any): number {
		const n = Math.trunc(Number(ordem))
		return Number.isFinite(n) && n >= 1 ? n : Number.POSITIVE_INFINITY
	}

	clamp(n: number, min: number, max: number): number {
		return Math.max(min, Math.min(max, n))
	}

	aplicarReordenacaoPorPosicao(item: TipoDePagamento, ordemDesejada: any): number {
		const target = this.normalizarOrdemEntrada(ordemDesejada)
		const comIndice = this.tipos.map((t, idx) => ({ t, idx }))
		const outros = comIndice.filter(x => x.t.id !== item.id)

		outros.sort((a, b) => {
			const oa = this.ordemParaOrdenar(a.t.ordem)
			const ob = this.ordemParaOrdenar(b.t.ordem)
			if (oa !== ob) return oa - ob
			return a.idx - b.idx
		})

		const lista = outros.map(x => x.t)

		const pos = this.clamp(target, 1, lista.length + 1)
		lista.splice(pos - 1, 0, item)

		this.tipos.splice(0, this.tipos.length, ...lista)

		this.tipos.forEach((t, i) => {
			t.ordem = i + 1
		})

		return item.ordem
	}
}

interface DisplayTiposDePagamento extends TipoDePagamento {
	displayParcelas: string
}

